import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=171ff8a4"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=171ff8a4&prod&lang=css"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=171ff8a4&prod&scropeed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports